import { jsx as s, jsxs as p } from "react/jsx-runtime";
import j from "../link-wrapper/link-wrapper.js";
import o from "./link.module.less.js";
const N = ({ className: n, ...r }) => /* @__PURE__ */ s(d, { className: [o.primary, n ?? ""].join(" "), ...r }), L = ({ className: n, ...r }) => /* @__PURE__ */ s(l, { className: [o.primary, n ?? ""].join(" "), ...r }), b = ({ className: n, ...r }) => /* @__PURE__ */ s(u, { className: [o.primary, n ?? ""].join(" "), ...r }), h = ({ className: n, ...r }) => /* @__PURE__ */ s(d, { className: [o.secondary, n ?? ""].join(" "), ...r }), B = ({ className: n, ...r }) => /* @__PURE__ */ s(l, { className: [o.secondary, n ?? ""].join(" "), ...r }), C = ({ className: n, ...r }) => /* @__PURE__ */ s(u, { className: [o.secondary, n ?? ""].join(" "), ...r }), i = () => ["body-base mb-0", o.common].join(" "), m = ({ iconRight: n, iconLeft: r, label: a }) => /* @__PURE__ */ p(
  "div",
  {
    className: [
      o.labelWrapper,
      n ? o.paddedIconRight : "",
      r ? o.paddedIconLeft : ""
    ].join(" "),
    children: [
      r && /* @__PURE__ */ s("span", { className: `${o.icon} ${o.iconLeft} ${r}` }),
      /* @__PURE__ */ s("div", { className: o.label, children: a }),
      n && /* @__PURE__ */ s("span", { className: `${o.icon} ${o.iconRight} ${n}` })
    ]
  }
), l = ({ className: n, label: r, iconLeft: a, iconRight: e, openInNewTab: t, url: c, onPreNavigate: y }) => {
  const k = i();
  return /* @__PURE__ */ s(
    j,
    {
      onPreNavigate: y,
      className: [o.link, n ?? "", k].join(" "),
      target: t ? "_blank" : void 0,
      url: c,
      rel: "noreferrer",
      children: /* @__PURE__ */ s(m, { iconLeft: a, iconRight: e, label: r })
    }
  );
}, d = ({ className: n, onClick: r, label: a, iconLeft: e, iconRight: t }) => {
  const c = i();
  return /* @__PURE__ */ s("button", { type: "button", className: [o.button, n ?? "", c].join(" "), onClick: r, children: /* @__PURE__ */ s(m, { iconLeft: e, iconRight: t, label: a }) });
}, u = ({ className: n, label: r, iconLeft: a, iconRight: e }) => {
  const t = i();
  return /* @__PURE__ */ s("div", { className: [o.button, o.fake, n ?? "", t].join(" "), children: /* @__PURE__ */ s(m, { iconLeft: a, iconRight: e, label: r }) });
}, f = {
  Primary: L,
  Secondary: B
}, v = {
  Primary: N,
  Secondary: h
}, F = {
  Primary: b,
  Secondary: C
};
export {
  f as LinkAnchor,
  v as LinkButton,
  F as LinkFake
};
